<template>
  <div class="userGroup">
    <el-divider content-position="left">企业微信群</el-divider>
    <el-row class="mb-10">
      <el-col :span="12">
        <el-select
          clearable
          v-model="searchArr.chat_id"
          filterable
          remote
          reserve-keyword
          placeholder="输入群名搜素"
          size="mini"
          :remote-method="searchNameremoteMethod"
          :loading="searchLoading"
          @change="handleSearchNameChange"
        >
          <el-option
            v-for="searchChat in searchChatList"
            :key="searchChat.chat_id"
            :label="searchChat.name"
            :value="searchChat.chat_id"
          >
          </el-option>
        </el-select>
        <el-popover placement="bottom-start" v-model="visible" width="320">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="绑定公司" prop="isBind">
              <el-select
                v-model="searchArr.isBind"
                placeholder="请选择是否绑定公司"
                size="mini"
                clearable
              >
                <el-option label="未绑定" :value="1"></el-option>
                <el-option label="已绑定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="群主" prop="owner">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.owner"
                placeholder="请选择群主"
                :options="admins"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="无聊天记录" prop="not_messages">
              <el-select
                v-model="searchArr.not_messages"
                placeholder="请选择是否绑定公司"
                size="mini"
                clearable
              >
                <el-option label="7天" :value="7"></el-option>
                <el-option label="15天" :value="15"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="财税负责人" prop="leader_id">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.leader_id"
                placeholder="请选择财税负责人筛选"
                :options="admins"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="理票会计" prop="acc_id">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.acc_id"
                placeholder="请选择理票会计筛选"
                :options="admins"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="客服会计" prop="ass_id">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.ass_id"
                placeholder="请选择客服会计筛选"
                :options="admins"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="记账报税会计" prop="advisory_id">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.advisory_id"
                placeholder="请选择记账报税会计筛选"
                :options="admins"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="业务员" prop="saler_id">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.saler_id"
                placeholder="请选择业务员筛选"
                :options="admins"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="人员不在的群" prop="not_in_group">
              <el-checkbox-group v-model="searchArr.not_in_group" size="mini">
                <el-checkbox border style="width: 100%"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="tr">
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="submitForm('searchForm')" size="mini"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
      <el-col :span="4" class="tr"
        ><span class="count">总数：{{ pageOption.total }}</span></el-col
      >
      <el-col :span="8" class="tr">
        <el-button type="primary" size="mini" @click="openChatSortCount"
          >总聊天记录排行榜</el-button
        >
        <el-button type="primary" size="mini" @click="openChatTotalCount"
          >总聊天记录统计</el-button
        >
        <el-popconfirm title="确定更新吗？" @onConfirm="handleUp">
          <el-button type="primary" slot="reference" size="mini">更新群</el-button>
        </el-popconfirm>
        <el-popconfirm title="确定更新吗？" @onConfirm="handleUpChat">
          <el-button type="primary" slot="reference" size="mini">更新群聊</el-button>
        </el-popconfirm>
      </el-col>
    </el-row>
    <div class="header-con">
      <el-row class="m-con" :gutter="10">
        <el-col
          class="chat-list messages-list"
          :span="6"
          v-scroll-loading="chatScrollBottom"
          ref="chatList"
        >
          <div class="list">
            <div
              class="list_chat hide-style"
              :class="[selectId === chat.chat_id ? 'active' : '']"
              v-for="(chat, index) in chats"
              :key="index"
            >
              <el-row>
                <el-col :span="20" class="hide-style" style="height: 0.8rem">
                  <el-tooltip :content="chat.name" placement="top">
                    <span
                      style="cursor: pointer"
                      @click="handleMessages(chat.chat_id, chat.name)"
                      >{{ chat.name }}</span
                    >
                  </el-tooltip>
                  <div v-if="chat.last_message" class="msg-content hide-style">
                    <el-tooltip
                      v-if="chat.last_message.msgtype === 'text'"
                      :content="chat.last_message.content"
                      placement="top"
                    >
                      <span>{{ chat.max_time }}：{{ chat.last_message.content }}</span>
                    </el-tooltip>
                    <span v-else-if="chat.last_message.msgtype === 'image'"
                      >{{ chat.max_time }}：[图片]</span
                    >
                  </div>
                </el-col>
                <el-col :span="4">
                  <i
                    style="color: #5789f4"
                    v-if="chat.is_company_bind"
                    class="el-icon-check"
                  ></i>
                  <el-dropdown trigger="click" @command="handleCommand" class="more-icon">
                    <span class="el-dropdown-link"><i class="el-icon-s-fold"></i></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        :command="{
                          action: 'bind',
                          id: chat.chat_id,
                          index: index,
                        }"
                        >绑定公司</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
              <el-divider style="margin: 0"></el-divider>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <wx-work-chat :chatId="selectId" :chatName="selectName"></wx-work-chat>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="绑定公司"
      :visible.sync="bindDialogVisible"
      width="40%"
      :before-close="handleBindClose"
    >
      <el-select
        v-model="companyId"
        multiple
        filterable
        remote
        reserve-keyword
        placeholder="输入公司"
        size="mini"
        clearable
        :remote-method="remoteMethod"
        :loading="loading"
      >
        <el-option
          v-for="company in companys"
          :key="company.id"
          :label="company.company_name"
          :value="company.id"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleBindSub">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="totalCountDialog" fullscreen @close="handleChatInfoClose">
      <!-- title="总聊天记录统计" -->
      <div style="font-size: x-large; font-weight: bold; color: black" slot="title">
        总聊天记录统计
      </div>
      <div class="mt-pd-2" style="margin-bottom: 0.2rem">
        <div style="text-align: left">
          <el-date-picker
            v-model="member_count_chooise_date"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="typeInPickerOptions"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="mini"
            @change="handleGetMemberCount"
          >
          </el-date-picker>
          <el-select
            v-model="filter_member_count"
            placeholder="少于多少条不展示？"
            size="mini"
            style="vertical-align: top; width: auto"
            @change="HandleFilterMemberCount"
            clearable
            filterable
          >
            <el-option label="5" value="5"> </el-option>
            <el-option label="10" value="10"> </el-option>
            <el-option label="30" value="30"> </el-option>
            <el-option label="50" value="50"> </el-option>
            <el-option label="80" value="80"> </el-option>
            <el-option label="100" value="100"> </el-option>
            <el-option label="200" value="200"> </el-option>
          </el-select>
          <el-radio-group
            v-model="groupOrPersonal"
            size="mini"
            @change="chooseChatType"
            style="float: right"
          >
            <el-radio-button label="group">群聊</el-radio-button>
            <el-radio-button label="personal">私聊</el-radio-button>
            <el-radio-button label="all">全部</el-radio-button>
          </el-radio-group>
          <p>
            <i
              class="el-icon-s-opportunity"
              style="
                color: #e6a23c;
                font-size: x-small;
                display: block;
                margin-top: 0.1rem;
              "
              >没有选择日期默认是今天</i
            >
          </p>
          <div style="text-align: right">
            <span class="fs-s" style="color: ; margin-left: 0.2rem"
              >聊天总数：{{ chatTotal }}</span
            >
            <span class="fs-s" style="color: #409eff; margin-left: 0.1rem"
              >我方：{{ chatOur }}</span
            >
            <span class="fs-s" style="color: #67c23a; margin-left: 0.1rem"
              >客户：{{ chatCustomer }}</span
            >
            <span
              class="fs-s"
              style="color: #e6a23c; margin-left: 0.1rem"
              v-if="chatRobot > 0"
              >群机器人：{{ chatRobot }}</span
            >
          </div>
        </div>
        <!-- <div>
          <span
            v-if="pieData.length > 0"
            style="
              display: inline-block;
              font-size: medium;
              color: black;
              font-weight: 700;
              margin-top: 0.8rem;
            "
            >我方数据:</span
          >
        </div> -->
      </div>
      <div
        id="mychart_dialog"
        :style="myChartStyle"
        style="clear: both; margin-top: 0.2rem"
      ></div>
      <!-- <div>
      <div>
          <span
            v-if="customer_pieData.length > 0"
            style="
            display: inline-block;
              font-size: medium;
              color: black;
              font-weight: 700;
              margin-top: 0.8rem;
              margin-left: 0.2rem
            "
            >客户数据:</span
          >
        </div>
      </div>
      <div
        id="customer_chart"
        :style="myChartStyle"
        style="clear: both; margin-top: 0.2rem"
      ></div> -->
    </el-dialog>
    <el-dialog
      :visible.sync="sortCountDialog"
      fullscreen
      @close="handleSortCountDialogClose"
    >
      <div style="font-size: x-large; font-weight: bold; color: black" slot="title">
        总聊天记录排行榜
      </div>
      <div class="mt-pd-2" style="margin-bottom: 0.2rem">
        <div style="text-align: left">
          <el-date-picker
            v-model="member_sort_chooise_date"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="typeInPickerOptions"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="mini"
            @change="handleGetMemberCount_sort"
          >
          </el-date-picker>
          <el-select
            v-model="filter_sort_count"
            placeholder="少于多少条不展示？"
            size="mini"
            style="vertical-align: top; width: auto"
            @change="HandleFilterMemberCount_sort"
            clearable
            filterable
          >
            <el-option label="5" value="5"> </el-option>
            <el-option label="10" value="10"> </el-option>
            <el-option label="30" value="30"> </el-option>
            <el-option label="50" value="50"> </el-option>
            <el-option label="80" value="80"> </el-option>
            <el-option label="100" value="100"> </el-option>
            <el-option label="200" value="200"> </el-option>
          </el-select>
          <el-radio-group
            v-model="groupOrPersonal"
            size="mini"
            @change="chooseChatType_sort"
            style="float: right"
          >
            <el-radio-button label="group">群聊</el-radio-button>
            <el-radio-button label="personal">私聊</el-radio-button>
            <el-radio-button label="all">全部</el-radio-button>
          </el-radio-group>
          <p>
            <i
              class="el-icon-s-opportunity"
              style="
                color: #e6a23c;
                font-size: x-small;
                display: block;
                margin-top: 0.1rem;
              "
              >没有选择日期默认是今天</i
            >
          </p>
          <div style="text-align: right">
            <span class="fs-s" style="color: ; margin-left: 0.2rem"
              >聊天总数：{{ chatTotal }}</span
            >
            <span class="fs-s" style="color: #409eff; margin-left: 0.1rem"
              >我方：{{ chatOur }}</span
            >
            <span class="fs-s" style="color: #67c23a; margin-left: 0.1rem"
              >客户：{{ chatCustomer }}</span
            >
            <span
              class="fs-s"
              style="color: #e6a23c; margin-left: 0.1rem"
              v-if="chatRobot > 0"
              >群机器人：{{ chatRobot }}</span
            >
          </div>
        </div>
      </div>
      <div class="echart" id="column" :style="columnStyle"></div>

      <div style="margin-top: 1rem">
        <el-table
          max-height="650"
          :data="tablelData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="id" label="排名" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.real_name != null ? scope.row.real_name.name : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="member_count" label="聊天总条数" align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import WxWorkChat from "common/WxWorkChat";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "UserGroup",
  components: {
    WxWorkChat,
  },
  data() {
    return {
      groupOrPersonal: "all",
      tablelData: [],
      yName: [],
      xData: [],
      yData: [],
      columnStyle: { float: "left", width: "100%", height: "800px" }, // 图表样式
      sortCountDialog: false,
      filter_sort_count: "",
      member_sort_chooise_date: "",
      total_count: [],
      pieName: [],
      pieData: [],
      myChartStyle: { float: "left", width: "100%", height: "1200px" }, // 图表样式
      member_count_chooise_date: "",
      filter_member_count: "",
      customerChart: {},
      customer_count: [],
      customer_pieName: [],
      customer_pieData: [],
      needChatId: "",
      totalCountDialog: false,
      chatTotal: 0,
      chatOur: 0,
      chatCustomer: 0,
      chatRobot: 0,
      visible: false,
      searchArr: {
        chat_id: "",
        isBind: "",
        owner: null,
        not_messages: "",
        leader_id: "",
        acc_id: "",
        ass_id: "",
        advisory_id: "",
        saler_id: "",
        not_in_group: false,
      },
      searchChatList: [],
      searchLoading: false,
      admins: [],
      chats: [],
      chatLoading: false,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示条数
      },
      selectId: null,
      selectName: "",
      toBottom: false,
      chatComplete: false,
      complete: false,
      oldHeight: 0,
      bindDialogVisible: false,
      loading: false,
      companyId: [],
      bindChatId: null,
      bingChatIndex: null,
      companys: [],
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    typeInPickerOptions: function () {
      var _this = this;
      return {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const todayDate = new Date().toLocaleDateString();
              var dateArr = _this.nowDate(todayDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const dd = new Date();
              dd.setDate(dd.getDate() - 1);
              var yesterDate = dd.toLocaleDateString();
              var dateArr = _this.nowDate(yesterDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var now = new Date();
              const year = now.getFullYear();
              const month = now.getMonth();
              const day = now.getDate();
              const week = now.getDay();

              let start = new Date(year, month, day - week + 1, 0, 0, 0);
              let end = new Date(year, month, day - week + 7, 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              var dateS = _this.getWeek(-1, 0).split("-");
              var dateE = _this.getWeek(-1, 1).split("-");

              let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0);
              let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              var str = _this.getCurrentDate();

              var arr = _this.getfirstDateAndlastDate(str);

              var arrS = arr[0].split("-");
              var arrE = arr[1].split("-");

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              var str = _this.fromLastMonth();

              var arr = _this.getfirstDateAndlastDate(str);

              var arrS = arr[0].split("-");
              var arrE = arr[1].split("-");

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    chooseChatType() {
      this.handleGetMemberCount();
    },
    chooseChatType_sort() {
      this.handleGetMemberCount_sort();
    },
    nowDate(date) {
      return date.split("/");
    },
    getWeek(n, type) {
      // 周
      let now = new Date();
      let day = now.getDay(); // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1);
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7);
        } else {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber);
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1 + 6); // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7 + 6);
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber);
        }
      }
      let date = now.getDate();
      let month = now.getMonth() + 1;

      let s =
        now.getFullYear() +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (date < 10 ? "0" + date : date);
      return s;
    },
    getfirstDateAndlastDate(dateC) {
      var dateStr = dateC;
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month > 12) {
        month = 1;
        year++;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var monthLastDay = new Date(year, month, 0).getDate();
      var firstDate = year + "-" + month + "-" + "01";
      var lastDate = year + "-" + month + "-" + monthLastDay;
      return [firstDate, lastDate];
    },
    getCurrentDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    fromLastMonth() {
      var date = new Date();
      var lastMonthDate = "";
      // 获取当前几号，如果小于10则补0
      var day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      var month = date.getMonth();
      var year = date.getFullYear();
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + "-12-" + day;
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = "0" + month;
        }
        lastMonthDate = year + "-" + month + "-" + day;
      }
      return lastMonthDate;
    },
    handleChatInfoClose() {
      this.groupOrPersonal = "all";
      this.filter_member_count = "";
      this.member_count_chooise_date = "";
    },
    handleSortCountDialogClose() {
      this.groupOrPersonal = "all";
      this.filter_member_count = "";
      this.member_count_chooise_date = "";
    },
    handleGetMemberCount() {
      this.pieData = [];
      this.pieName = [];
      this.total_count = [];
      this.chatTotal = 0;
      this.chatOur = 0;
      this.chatCustomer = 0;
      this.chatRobot = 0;
      this.customer_pieData = [];
      this.customer_pieName = [];
      this.$axios
        .get(
          "api/admin/total_count?date=" +
            this.member_count_chooise_date +
            "&type=" +
            this.groupOrPersonal
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.chatTotal = data.count.total;
            this.total_count = data.data;
            // this.customer_count = data.customer
            this.chatOur = data.count.our;
            this.chatCustomer = data.count.customer;
            this.chatRobot = data.count.robot;
            this.initDate(); // 数据初始化
            this.initEcharts();
            // this.initDate_customer() // 数据初始化
            // this.initEcharts_customer()
          }
        })
        .catch();
    },
    handleGetMemberCount_sort() {
      this.xData = [];
      this.yData = [];
      this.total_count = [];
      this.chatTotal = 0;
      this.chatOur = 0;
      this.chatCustomer = 0;
      this.chatRobot = 0;
      this.customer_pieData = [];
      this.customer_pieName = [];
      this.$axios
        .get(
          "api/admin/total_count?date=" +
            this.member_sort_chooise_date +
            "&type=" +
            this.groupOrPersonal
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.chatTotal = data.count.total;
            this.total_count = data.data;
            this.tablelData = data.data;
            // this.customer_count = data.customer
            this.chatOur = data.count.our;
            this.chatCustomer = data.count.customer;
            this.chatRobot = data.count.robot;
            this.initDate_column(); // 数据初始化
            this.initEcharts_column();
            // this.initDate_customer() // 数据初始化
            // this.initEcharts_customer()
          }
        })
        .catch();
    },
    HandleFilterMemberCount(val) {
      this.pieData = [];
      this.pieName = [];
      // this.HandleFilterMemberCount_customer(val)
      for (let i = 0; i < this.total_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        if (this.total_count[i].member_count >= val) {
          this.pieName[i] =
            this.total_count[i].real_name != null
              ? this.total_count[i].real_name.name
              : "";
          this.pieData[i] = {
            name:
              this.total_count[i].real_name != null
                ? this.total_count[i].real_name.name
                : "",
            value: this.total_count[i].member_count,
          };
        }
      }
      this.initEcharts();
    },
    HandleFilterMemberCount_sort(val) {
      this.xData = [];
      this.yData = [];
      this.yName = [];
      // this.HandleFilterMemberCount_customer(val)
      for (let i = 0; i < this.total_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        if (this.total_count[i].member_count >= val) {
          // this.xData[i] = i;
          // this.yData =this.xData[i]*this.xData[i];
          this.xData[i] = "第" + (i + 1) + "名";
          // this.yData[i] =
          //   this.total_count[i].real_name +
          //   '' +
          //   this.total_count[i].member_count
          this.yData[i] = this.total_count[i].member_count;
          this.yName[i] =
            this.total_count[i].real_name != null
              ? this.total_count[i].real_name.name
              : "";
        }
      }
      this.initEcharts_column();
    },
    HandleFilterMemberCount_customer(val) {
      this.customer_pieData = [];
      this.customer_pieName = [];
      for (let i = 0; i < this.customer_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        if (this.customer_count[i].member_count >= val) {
          this.customer_pieName[i] =
            this.customer_count[i].real_name != null
              ? this.customer_count[i].real_name.name
              : "";
          this.customer_pieData[i] = {
            name:
              this.customer_count[i].real_name != null
                ? this.customer_count[i].real_name.name
                : "",
            value: this.customer_count[i].member_count,
          };
        }
      }
      this.initEcharts_customer();
    },
    openChatTotalCount() {
      this.handleGetMemberCount();
      this.totalCountDialog = true;
    },
    openChatSortCount() {
      this.handleGetMemberCount_sort();
      this.sortCountDialog = true;
    },
    initEcharts_column() {
      // 基本柱状图
      const option = {
        // color: [
        //   '#33b56a',
        //   '#fdcf5c',
        //   '#4c90ff',
        //   '#fe7b7a',
        //   '#69ccf6',
        //   '#a38bf8',
        //   '#ff9561',
        //   '#8cb0ea',
        //   '#fe81b4',
        //   '#ffb258'
        // ],
        color: ["#fe7b7a"],
        legend: {
          show: true,
          top: 25,
        },
        grid: {
          left: "3%",
          right: "4%",
          top: "15%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: 'none' // 中间横线
            type: "shadow", // 中间横线
          },
        },
        xAxis: {
          type: "category",
          data: this.xData,
          boundaryGap: true,
          interval: 0,
          axisLabel: {
            color: "#333",
            //  让x轴文字方向为竖向
            // interval: 0,
            formatter: function (value) {
              // return value.split('').join('n')
              return value;
            },
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "bar", // 形状为柱状图
            data: this.yData,
            barWidth: 30,
            smooth: false,
            itemStyle: {
              normal: {
                color: function (params) {
                  // 使每根柱子颜色都不一样
                  // let colorList = [
                  //   '#33b56a',
                  //   '#fdcf5c',
                  //   '#4c90ff',
                  //   '#fe7b7a',
                  //   '#69ccf6',
                  //   '#a38bf8',
                  //   '#ff9561',
                  //   '#8cb0ea',
                  //   '#fe81b4',
                  //   '#ffb258'
                  // ]
                  let colorList = ["#fe7b7a"];
                  if (params.dataIndex + 1 <= colorList.length) {
                    return colorList[params.dataIndex];
                  } else {
                    // 如果柱子的数量超过颜色数组 就从头再来一遍
                    return colorList[params.dataIndex - colorList.length];
                  }
                },
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#333",
              // formatter: `{c}次`,
              formatter: (value) => {
                var str = "";
                this.yName.map((item, index, arr) => {
                  if (index === value.dataIndex) {
                    str = item + value.data;
                  }
                });
                return str;
              },
              fontSize: 16,
              distance: 15,
            },
          },
        ],
      };
      const column = echarts.init(document.getElementById("column"));
      column.setOption(option);
      // 随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        column.resize();
      });
    },
    initDate() {
      for (let i = 0; i < this.total_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        this.pieName[i] =
          this.total_count[i].real_name != null ? this.total_count[i].real_name.name : "";
        this.pieData[i] = {
          name:
            this.total_count[i].real_name != null
              ? this.total_count[i].real_name.name
              : "",
          value: this.total_count[i].member_count,
        };
      }
    },
    initDate_column() {
      for (let i = 0; i < this.total_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        this.xData[i] = "第" + (i + 1) + "名";
        // this.yData[i] =
        //   this.total_count[i].real_name +
        //   '' +
        //   this.total_count[i].member_count
        this.yData[i] = this.total_count[i].member_count;
        this.yName[i] =
          this.total_count[i].real_name != null ? this.total_count[i].real_name.name : "";
      }
    },
    initEcharts() {
      // 饼图
      const option = {
        tooltip: {
          // 提示框组件
          trigger: "item", // 触发类型,'item'数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。 'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
          triggerOn: "mousemove", // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          triggerOff: "mousemout", // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          showContent: true, // 是否显示提示框浮层
          alwaysShowContent: false, // 是否永远显示提示框内容
          showDelay: 0, // 浮层显示的延迟，单位为 ms
          hideDelay: 100, // 浮层隐藏的延迟，单位为 ms
          enterable: false, // 鼠标是否可进入提示框浮层中
          confine: false, // 是否将 tooltip 框限制在图表的区域内
          transitionDuration: 0.4, // 提示框浮层的移动动画过渡时间，单位是 s,设置为 0 的时候会紧跟着鼠标移动
          // position: ['50%', '50%'], // 提示框浮层的位置，默认不设置时位置会跟随鼠标的位置,[10, 10],回掉函数，inside鼠标所在图形的内部中心位置，top、left、bottom、right鼠标所在图形上侧，左侧，下侧，右侧，
          // formatter: '{b0}: {c0}<br />{b1}: {c1}', // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式,模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等
          formatter: "{b} : {c} <br/>百分比 : {d}%", // {a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
          backgroundColor: "transparent", // 标题背景色
          borderColor: "#ccc", // 边框颜色
          borderWidth: 0, // 边框线宽
          padding: 5, // 图例内边距，单位px  5  [5, 10]  [5,10,5,10]
          // textStyle: mytextStyle // 文本样式
        },
        legend: {
          // 图例
          data: this.pieName,
          right: "0%",
          top: "10%",
          orient: "vertical",
        },
        // title: {
        //   // 设置饼图标题，位置设为顶部居中
        //   text: '聊天记录统计',
        //   top: '0%',
        //   left: 'center'
        // },
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b} : {c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "45%", // 饼图半径
            center: ["40%", "35%"], // 饼图位置 左右,上下
            data: this.pieData,
          },
        ],
      };
      console.log(this.seriesData);
      const optionFree = {
        xAxis: {},
        yAxis: {},
        series: [
          {
            data: this.seriesData,
            type: "line",
            smooth: true,
          },
        ],
      };
      console.log(optionFree);
      this.myChart = echarts.init(document.getElementById("mychart_dialog"));
      this.myChart.setOption(option);
      // 随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    initDate_customer() {
      for (let i = 0; i < this.customer_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        this.customer_pieName[i] =
          this.customer_count[i].real_name != null
            ? this.customer_count[i].real_name.name
            : "";
        this.customer_pieData[i] = {
          name:
            this.customer_count[i].real_name != null
              ? this.customer_count[i].real_name.name
              : "",
          value: this.customer_count[i].member_count,
        };
      }
    },
    initEcharts_customer() {
      // 饼图
      const option1 = {
        tooltip: {
          // 提示框组件
          trigger: "item", // 触发类型,'item'数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。 'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
          triggerOn: "mousemove", // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          triggerOff: "mousemout", // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          showContent: true, // 是否显示提示框浮层
          alwaysShowContent: false, // 是否永远显示提示框内容
          showDelay: 0, // 浮层显示的延迟，单位为 ms
          hideDelay: 100, // 浮层隐藏的延迟，单位为 ms
          enterable: false, // 鼠标是否可进入提示框浮层中
          confine: false, // 是否将 tooltip 框限制在图表的区域内
          transitionDuration: 0.4, // 提示框浮层的移动动画过渡时间，单位是 s,设置为 0 的时候会紧跟着鼠标移动
          // position: ['50%', '50%'], // 提示框浮层的位置，默认不设置时位置会跟随鼠标的位置,[10, 10],回掉函数，inside鼠标所在图形的内部中心位置，top、left、bottom、right鼠标所在图形上侧，左侧，下侧，右侧，
          // formatter: '{b0}: {c0}<br />{b1}: {c1}', // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式,模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等
          formatter: "{b} : {c} <br/>百分比 : {d}%", // {a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
          backgroundColor: "transparent", // 标题背景色
          borderColor: "#ccc", // 边框颜色
          borderWidth: 0, // 边框线宽
          padding: 5, // 图例内边距，单位px  5  [5, 10]  [5,10,5,10]
          // textStyle: mytextStyle // 文本样式
        },
        legend: {
          // 图例
          data: this.customer_pieName,
          right: "0%",
          top: "10%",
          orient: "vertical",
        },
        // title: {
        //   // 设置饼图标题，位置设为顶部居中
        //   text: '聊天记录统计',
        //   top: '0%',
        //   left: 'center'
        // },
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b} : {c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "45%", // 饼图半径
            center: ["40%", "35%"], // 饼图位置 左右,上下
            data: this.customer_pieData,
          },
        ],
      };
      // console.log(this.seriesData)
      const optionFree1 = {
        xAxis: {},
        yAxis: {},
        series: [
          {
            data: this.seriesData,
            type: "line",
            smooth: true,
          },
        ],
      };
      console.log(optionFree1);
      this.customerChart = echarts.init(document.getElementById("customer_chart"));
      this.customerChart.setOption(option1);
      // 随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.customerChart.resize();
      });
    },
    getChats(isSearch) {
      isSearch = isSearch || false;
      this.$axios
        .get("/api/admin/userGroups?page=" + this.pageOption.currentPage + this.searchStr)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            if (!isSearch) {
              this.chats.push(...data.data.chats.data);
              this.chatLoading = true;
            } else {
              this.chats = data.data.chats.data;
              this.chatLoading = false;
            }
            this.setChats(data.data.chats.data);
            this.pageOption.total = data.data.chats.total;
            this.chatComplete = data.data.chats.data.length === 0;
            this.admins = data.data.admins;
          } else {
            this.$message.warning(data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getChats();
    },
    setChats(data) {
      let chatIds = [];
      for (var i = 0; i < data.length; i++) {
        chatIds.push(data[i].chat_id);
      }

      this.$axios
        .post(
          "/api/admin/userGroup/setChats",
          { chatIds: chatIds },
          { loadingClose: true }
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            for (let i = 0; i < data.data.length; i++) {
              for (let j = 0; j < this.chats.length; j++) {
                if (this.chats[j].chat_id === data.data[i].chatId) {
                  this.chats[j].is_company_bind = data.data[i].is_company_bind;
                  this.chats[j].last_message = data.data[i].last_message;
                }
              }
            }
          }
        });
    },
    handleMessages(id, chatName) {
      this.selectId = id;
      this.selectName = chatName;
    },
    searchNameremoteMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchChats(query);
        }, 200);
      } else {
        this.users = [];
      }
    },
    searchChats(query) {
      this.$axios.get("/api/admin/userGroups/searchChats/" + query).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.searchChatList = data.data;
        }
      });
    },
    handleSearchNameChange(val) {
      this.selectId = null;
      this.selectName = null;
      this.pageOption.currentPage = 1;
      this.getChats(true);
    },
    chatScrollBottom() {
      let scrollTop = this.$refs.chatList.$el.scrollTop;
      let height = this.$refs.chatList.$el.scrollHeight;
      let clientHeight = this.$refs.chatList.$el.clientHeight;

      if (scrollTop + clientHeight === height && this.chatLoading) {
        if (!this.chatComplete) this.pageOption.currentPage++;
        this.getChats();
      }

      this.chatLoading = true;
    },
    handleUp() {
      this.$axios.post("/api/admin/userGroup/insert").then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.selectId = null;
          this.getChats(true);
          this.$message.success("更新完成！失败：" + data.data.failure);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleUpChat() {
      this.$axios.post("/api/admin/chatdata/insert").then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleCommand(command) {
      if (command.action === "bind") {
        this.handleBindCompany(command.id, command.index);
      }
    },
    handleBindCompany(chatID, index) {
      this.$axios.get("/api/admin/userGroup/company/" + chatID).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.bindChatId = chatID;
          this.bingChatIndex = index;
          this.bindDialogVisible = true;
          this.companys = data.data.companys;
          this.companyId = data.data.companyIds;
        }
      });
    },
    handleBindClose(done) {
      this.bindChatId = null;
      this.companyId = [];
      this.bingChatIndex = null;
      this.companys = [];
      done();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companys = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companys = data.data.companies;
        }
      });
    },
    handleBindSub() {
      if (!this.bindChatId) {
        this.$message.error("请求参数错误，请刷新重试");
        return;
      }

      if (!this.companyId) {
        this.$message.error("请选择公司");
        return;
      }

      this.$axios
        .post("/api/admin/userGroup/companyBind", {
          bindChatId: this.bindChatId,
          companyId: this.companyId,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.chats[this.bingChatIndex].is_company_bind = data.data.company;
            this.bindDialogVisible = false;
            this.bindChatId = null;
            this.companyId = null;
            this.bingChatIndex = null;
            this.companys = [];
            this.$message.success(data.msg);
            this.selectId = null;
            this.selectName = "";
            // this.date = +new Date()
          }
        });
    },
    resetForm(formName) {
      this.searchArr.chat_id = "";
      this.searchArr.not_in_group = false;
      this.searchArr.isBind = "";
      this.searchArr.owner = null;
      this.searchArr.not_messages = "";
      this.searchArr.leader_id = "";
      this.searchArr.acc_id = "";
      this.searchArr.ass_id = "";
      this.searchArr.advisory_id = "";
      this.searchArr.saler_id = "";
      this.selectId = null;
      this.selectName = null;
      this.pageOption.currentPage = 1;
      this.visible = false;
      this.getChats(true);
    },
    submitForm() {
      this.selectId = null;
      this.selectName = null;
      this.pageOption.currentPage = 1;
      this.visible = false;
      this.getChats(true, false);
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    this.getChats();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

.el-form .el-select {
  width: 100%;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.userGroup >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.userGroup >>> .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 0.5rem;
}

.userGroup >>> .video {
  background-color: #606266 !important;
  color: #fff !important;
}

.clearfix:before, .clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.tr {
  text-align: right;
}

.userGroup {
  marginLeft();

  .mt-10 {
    margin-top: 0.2rem;
  }

  .mt-50 {
    margin-top: 1rem;
  }

  .mb-10 {
    margin-bottom: 0.2rem;
  }

  .mb-0 {
    margin-bottom: 0 !important;
  }

  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .count {
    padding-left: 0.2rem;
    line-height: 0.56rem;
  }

  .m-tabs-content {
    padding: 0 0.2rem 0 0.4rem;
  }

  .infinite-list-item {
    margin: 0.2rem 0.2rem 0.4rem 0.2rem;
  }

  .infinite-item-content {
    display: inline-block;
    margin-top: 0.2rem;
    padding: 0 0.36rem 0 0.36rem;
    line-height: 0.9rem;
    background-color: #eef0f5;
  }

  .infinite-item-voice {
    display: inline-block;
    width: 1rem;
    margin-top: 0.2rem;
    padding: 0 0.36rem 0 0.36rem;
    line-height: 0.7rem;
    background-color: rgb(191, 221, 253);
    cursor: pointer;
  }

  .infinite-item-title {
    padding-left: 0.2rem;
  }

  .popper__arrow {
    position: absolute;
    top: 0.04rem;
    left: 0.36rem;
    display: block;
    margin-right: 0.06rem;
    border-color: transparent;
    border-style: solid;
    border-width: 0.18rem;
    border-top-width: 0;
    border-bottom-color: #eef0f5;
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  }

  .imgType {
    width: 2rem;
    cursor: pointer;
  }

  .imgerr {
    width: 4rem;
    height: 2rem;
    cursor: pointer;
  }

  .wrap {
    position: relative;
    width: 20px;
    height: 20px;
    margin: 0.1rem auto;
  }

  .box {
    position: absolute;
    width: 17px;
    height: 17px;
    left: 0;
    bottom: 0;
    background: #333;
    border-top-right-radius: 15px;
    transform: rotateZ(45deg);
    -webkit-transform: rotateZ(45deg);
  }

  .box-an {
    animation: obox linear 0.8s 5000;
  }

  @keyframes obox {
    0% {
      background: #333;
    }

    33% {
      background: #333;
    }

    66% {
      background: #fff;
    }

    100% {
      background: #333;
    }
  }

  @keyframes obox {
    0% {
      background: #333;
    }

    33% {
      background: #333;
    }

    66% {
      background: #fff;
    }

    100% {
      background: #333;
    }
  }

  .box1 {
    position: absolute;
    width: 15px;
    height: 15px;
    background-color: #bfddfd;
    left: 0;
    bottom: 0;
    border-top-right-radius: 15px;
  }

  .box2 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 12px;
    height: 12px;
    background: #333;
    border-top-right-radius: 15px;
  }

  .box2-an {
    animation: obox2 linear 1s 5000;
  }

  @keyframes obox2 {
    0% {
      background: #333;
    }

    33% {
      background: #333;
    }

    66% {
      background: #fff;
    }

    100% {
      background: #333;
    }
  }

  @keyframes obox2 {
    0% {
      background: #333;
    }

    33% {
      background: #333;
    }

    66% {
      background: #fff;
    }

    100% {
      background: #333;
    }
  }

  .box3 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 9px;
    height: 9px;
    background-color: #bfddfd;
    border-top-right-radius: 15px;
  }

  .box4 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 6px;
    height: 6px;
    background: #333;
    border-top-right-radius: 15px;
  }

  .infinite-item-file {
    width: 5rem;
    margin-top: 0.2rem;
    padding: 0.2rem 0.36rem;
    color: #FFF;
    background-color: #eef0f5;
    cursor: pointer;
  }

  .infinite-file-icon {
    padding: 0.2rem 0.12rem 0.2rem 0.12rem;
    font-size: 0.5rem;
    background-color: #1a61a8;
    text-align: center;
  }

  .infinite-file-name {
    padding-left: 0.2rem;
    text-align: right;
    color: #333;
  }

  .infinite-file-size {
    text-align: right;
    margin-top: 19px;
    font-size: 12px;
  }

  .hide-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .m-con {
    background-color: #fff;
    border-radius: 0.2rem 0.2rem 0 0;
  }

  .active {
    background-color: #eaeaea;
    color: #409eff;
  }

  .chat-list {
    height: 12rem;
    border-right: 1px solid #ebebeb;
  }

  .list {
    margin-top: 0.3rem;

    .el-divider--horizontal {
      margin: 0;
    }
  }

  .list_chat {
    margin-top: 0.2rem;
    user-select: none;
    padding: 0.1rem;
  }

  .list_chat:hover {
    color: #409eff;
  }

  .messages-list {
    min-height: calc(115vh - 210px);
    height: 6rem;
    border: solid 1px #DCDFE6;
    border-radius: 5px;
    border-bottom: none;
    overflow-y: auto;

    .messages-con {
      padding: 0.4rem;

      .message {
        padding: 0.2rem;
      }

      .image_con {
        padding: 0.2rem;
      }
    }
  }

  .msg-content {
    padding-top: 0.2rem;
    color: #ff6a00;
  }

  .el-dialog .el-select {
    width: 100%;
  }

  .more-icon {
    float: right;
    color: #5789F4;
    cursor: pointer;
  }
}

.el-form-item {
  margin-bottom: 0;
}

.fs-s {
  font-size: medium;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/conversation/UserGroup.vue